/**
 * @generated SignedSource<<fc385d44d13ca1facbbd3007cb97d173>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type richText_nativeIssueTable_RichTextCell$data = {
  readonly fieldId: string;
  readonly richText: {
    readonly adfValue: {
      readonly convertedPlainText: {
        readonly plainText: string | null | undefined;
      } | null | undefined;
    } | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "richText_nativeIssueTable_RichTextCell";
};
export type richText_nativeIssueTable_RichTextCell$key = {
  readonly " $data"?: richText_nativeIssueTable_RichTextCell$data;
  readonly " $fragmentSpreads": FragmentRefs<"richText_nativeIssueTable_RichTextCell">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "richText_nativeIssueTable_RichTextCell",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "fieldId"
    },
    {
      "concreteType": "JiraRichText",
      "kind": "LinkedField",
      "name": "richText",
      "plural": false,
      "selections": [
        {
          "concreteType": "JiraADF",
          "kind": "LinkedField",
          "name": "adfValue",
          "plural": false,
          "selections": [
            {
              "concreteType": "JiraAdfToConvertedPlainText",
              "kind": "LinkedField",
              "name": "convertedPlainText",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "plainText"
                }
              ]
            }
          ]
        }
      ]
    }
  ],
  "type": "JiraRichTextField"
};

(node as any).hash = "1a0c9dec8a75d610560982a633e52c7e";

export default node;
